/**
 * Where Kola is, as plain data: the current router path and the board it
 * names. Written by `RouteReporter` (App.tsx / embedded.tsx) from the
 * router's location; read by the debug report (which used to read
 * `window.location`, meaningless inside the desktop app where the URL is the
 * host's) and by the embedded shell, which forwards it to the host so the
 * desktop knows which board its Kola page is on.
 */
import { createStore } from "zustand/vanilla";

import { boardIdFromPath } from "./debug-log.js";

export interface RouteState {
  /** Router path + search, e.g. "/b/abc?cell=r1:c2". */
  path: string;
  /** The `/b/:boardId` on screen, or null off a board. */
  boardId: string | null;
}

export const routeStore = createStore<RouteState>(() => ({ path: "/", boardId: null }));

export function noteRoute(path: string): void {
  const boardId = boardIdFromPath(path);
  const current = routeStore.getState();
  if (current.path === path && current.boardId === boardId) return;
  routeStore.setState({ path, boardId });
}
